
function waitForAppstle(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelectorAll(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              observer.disconnect();
              resolve(document.querySelectorAll(selector));
          }
      });
      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

waitForAppstle('.appstle_subscription_wrapper_option').then((planItems) => {
  planItems.forEach(planItem => {
    planItem.addEventListener("click", (e) => {
      activePlan(e.currentTarget);
    });
  })
});

const activePlan = (element) => {
  const  sellingPlanVal = element.querySelector('input[name="selling_plan"]').value;
  document.getElementById("sellingPlan").setAttribute('value',sellingPlanVal);
}